import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";

const KEY = "mjp_cookie_notice_v1";

export default function CookieNotice() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try { setVisible(!localStorage.getItem(KEY)); } catch { setVisible(true); }
  }, []);

  const dismiss = () => {
    try { localStorage.setItem(KEY, new Date().toISOString()); } catch { /* private mode */ }
    setVisible(false);
  };

  if (!visible) return null;
  return (
    <div
      role="dialog"
      aria-label="Cookiemelding"
      data-testid="cookie-notice"
      className="fixed bottom-0 left-0 right-0 md:bottom-4 md:left-auto md:right-6 md:max-w-md z-50 border-t-2 md:border-2 border-foreground bg-card md:heavy-shadow p-3 md:p-4 flex gap-3 items-center md:items-start"
    >
      <Cookie className="w-5 h-5 shrink-0 text-secondary hidden md:block md:mt-0.5" />
      <div className="flex-1 text-xs md:text-sm leading-snug md:leading-relaxed">
        <div className="stat-label mb-1 hidden md:block">Cookies</div>
        <span className="md:hidden">Alleen <b>functionele cookies</b>, geen tracking.{" "}</span>
        <span className="hidden md:inline">Deze app gebruikt alleen <b>functionele cookies</b> om je ingelogd te houden. Geen tracking, geen advertenties.{" "}</span>
        <Link to="/privacy" data-testid="cookie-notice-privacy-link" className="underline hover:text-primary">Privacyverklaring</Link>
      </div>
      <button
        type="button"
        onClick={dismiss}
        data-testid="cookie-notice-accept"
        className="btn-brutal bg-primary text-primary-foreground px-3 py-1.5 font-display uppercase font-bold text-xs inline-flex items-center gap-1 shrink-0"
      >
        Begrepen <X className="w-3.5 h-3.5" />
      </button>
    </div>
  );
}
